import { useEffect, useState } from 'react';

export const useLoadingDots = (): number => {
	const [dotsAmount, setDotsAmount] = useState(1);
	useEffect(() => {
		let i = 0;
		const interval = window.setInterval(() => setDotsAmount(i++ % 4), 500);

		return (): void => clearInterval(interval);
	}, []);

	return dotsAmount;
};
